import { RouteObject, useLocation } from 'react-router';
import { useMemo } from 'react';
import { routes } from '@/router/Router';
import { Helmet } from 'react-helmet-async';

type CustomRouteObject = RouteObject & {
	title?: string; // title은 선택적으로 설정
};

const suffixTitle = '| 스텔라';
const findRouteTitle = (routes: CustomRouteObject[], pathname: string): CustomRouteObject | undefined => {
	for (const route of routes) {
		if (pathname === route.path || pathname.startsWith('/' + route.path)) {
			return route;
		}
		if (route.children) {
			const children =
				route.path === '/'
					? route.children
					: (route.children.map(item => {
							const path = item.path ? `/${item.path}` : '';
							return {
								...item,
								path: `${route.path}${path}`
							};
						}) as CustomRouteObject[]);
			const childTitle = findRouteTitle(children, pathname);
			if (childTitle) return childTitle;
		}
	}
	return undefined;
};

export const HeadTitle = () => {
	const { pathname } = useLocation();
	const pageTitle = useMemo(() => {
		const curTitle = findRouteTitle(routes, pathname);
		if (curTitle && curTitle.title) {
			return `${curTitle.title} ${suffixTitle}`;
		}
	}, [pathname]);

	return (
		<Helmet>
			<title>{pageTitle}</title>
		</Helmet>
	);
};
